import {
  api,
  IRequest,
  IResponse,
  ServiceError,
} from '@/services/api';
import { IClientAuthData } from '@/entities';

interface IGetClientAuthDataByAuthCodeBody {
  authCode: string;
}

interface IAuthClientRaw {
  entityId: string;
}

interface IGetClientAuthDataByAuthCodeResponseBody {
  client: IAuthClientRaw;
  token: string;
}

export const getClientAuthDataByAuthCode = async (
  { body }: IRequest<null, null, IGetClientAuthDataByAuthCodeBody>,
): IResponse<IClientAuthData> => {
  try {
    const response = await api.post<IGetClientAuthDataByAuthCodeResponseBody>('/auth/login/code', {
      code: body.authCode,
      useLegacyAuth: true,
    });

    return {
      id: response.data.client.entityId,
      token: response.data.token,
    };
  } catch (err) {
    throw new ServiceError(err);
  }
};
